import React, { useEffect, useState } from "react";
import { FaArrowLeft, FaUpload } from "react-icons/fa";
import { apiPostFormData, Get_Api } from "../../../API/Api_Url";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import LocationMap from "../../Modal/LocationMap";



function ConstructionRequirement() {
    const navigate = useNavigate()
    const [AllProjectType, setAllProjectType] = useState([]);
    const [IsLoading, setIsLoading] = useState(false);

    const getAllProjectType = async () => {
        try {
            setIsLoading(true);
            const response = await Get_Api("api/admin/GetAllProjectType");
            setAllProjectType(response?.data);
            setIsLoading(false);
        } catch (error) {
            setIsLoading(false);
            toast.error(error?.response?.data?.message);
            console.error(error);
        }
    };

    useEffect(() => {
        getAllProjectType();
    }, []);

    const [ProjectType, setProjectType] = useState("");
    const [SizeDimension, setSizeDimension] = useState({
        Length: "",
        Breadth: "",
        Unit: "",
        Area: ""
    });
    const [NumberOfFloors, setNumberOfFloors] = useState("");
    const [State, setState] = useState("");
    const [City, setCity] = useState("");
    const [Pincode, setPincode] = useState('');
    const [LocationAddress, setLocationAddress] = useState("");
    const [Latitude, setLatitude] = useState('786.7809');
    const [Longitude, setLongitude] = useState('67.899');
    const [Budget, setBudget] = useState("");
    const [PaymentMethod, setPaymentMethod] = useState("");
    const [TimelineInMonths, setTimelineInMonths] = useState("");
    const [NeedLocalAuthorityApproval, setNeedLocalAuthorityApproval] = useState(false);
    const [Images, setImages] = useState([]);

    const handleImageUpload = (e) => {
        const files = Array.from(e.target.files);
        setImages((prev) => [...prev, ...files]);
    };

    const removeImage = (index) => {
        setImages((prev) => prev.filter((_, i) => i !== index));
    };

    const [showConfirmation, setShowConfirmation] = useState(false);
    const [errors, setErrors] = useState({});

    const handleUploadRequirement = async () => {

        let newErrors = {};

        if (!ProjectType.trim()) newErrors.ProjectType = "Project Type is required";
        if (!SizeDimension.Length) newErrors.Length = "Length is required";
        if (!SizeDimension.Breadth) newErrors.Breadth = "Breadth is required";
        if (!SizeDimension.Unit) newErrors.Unit = "Unit is required";
        if (!SizeDimension.Area) newErrors.Area = "Area is required";
        if (!NumberOfFloors.trim() || isNaN(NumberOfFloors)) newErrors.NumberOfFloors = "Number of Floors is required";
        if (!State.trim()) newErrors.State = "State is required";
        if (!City.trim()) newErrors.City = "City is required";
        if (!Pincode.trim()) newErrors.Pincode = "Pincode is required";
        if (!LocationAddress.trim()) newErrors.LocationAddress = "Location Address is required";

        setErrors(newErrors);

        if (Object.keys(newErrors).length > 0) return;

        try {
            setIsLoading(true)
            const formData = new FormData();
            formData.append("ProjectType", ProjectType);
            formData.append("SizeDimension[Length]", SizeDimension.Length);
            formData.append("SizeDimension[Breadth]", SizeDimension.Breadth);
            formData.append("SizeDimension[Unit]", SizeDimension.Unit);
            formData.append("SizeDimension[Area]", SizeDimension.Area);
            formData.append("NumberOfFloors", NumberOfFloors);
            formData.append("State", State);
            formData.append("City", City);
            formData.append("Pincode", Pincode);
            formData.append("Location[Address]", LocationAddress);
            formData.append("Location[Late]", Latitude);
            formData.append("Location[Long]", Longitude);
            formData.append("Budget", Budget);
            formData.append("PaymentMethod", PaymentMethod || "Milestone");
            formData.append("TimelineInMonths", TimelineInMonths);
            formData.append("NeedLocalAuthorityApproval", NeedLocalAuthorityApproval);

            Images.forEach((img) => {
                formData.append("Image", img);
            });

            const response = await apiPostFormData('/api/user/UserCreateConstructionRequirement', formData)
            if (response?.data) {
                setProjectType("");
                setSizeDimension("");
                setNumberOfFloors("");
                setState("");
                setCity("");
                setPincode("");
                setLocationAddress('')
                setBudget("");
                setPaymentMethod("");
                setTimelineInMonths("");
                setNeedLocalAuthorityApproval("");
                setImages([]);
                setIsLoading(false)
                setShowConfirmation(true);

                setTimeout(() => {
                    setShowConfirmation(false);
                    navigate("/");
                }, 3000);
            }
            else {
                setIsLoading(false)
                toast.success(response?.message);
            }
        } catch (error) {
            setIsLoading(false)
            console.error("Error uploading requirement:", error);
            toast.error("Something went wrong. Please try again.");
        }
    };

    useEffect(() => {
        const length = Number(SizeDimension.Length);
        const breadth = Number(SizeDimension.Breadth);
        const floors = Number(NumberOfFloors);

        if (length > 0 && breadth > 0 && floors > 0) {
            let area = length * breadth * floors;

            let areaString

            if (SizeDimension.Unit === "sq. m.") {
                areaString = `${area} sq. m.`;
            }
            if (SizeDimension.Unit === "sq. ft.") {
                areaString = `${area} sq. ft.`;
            }

            setSizeDimension((prev) => ({
                ...prev,
                Area: areaString
            }));
        } else {
            setSizeDimension((prev) => ({
                ...prev,
                Area: ""
            }));
        }
    }, [SizeDimension.Length, SizeDimension.Breadth, SizeDimension.Unit, NumberOfFloors]);

    return (
        <>
            {
                showConfirmation ?
                    <>
                        <div className="pt-[3%] pb-[5%]">
                            <div className="max-w-4xl mx-auto bg-white rounded-2xl shadow-lg p-8">
                                <div className="flex items-center mb-6">
                                    <h2 className="text-2xl font-semibold text-gray-800">
                                        Add Construction Requirement
                                    </h2>
                                </div>
                                <div className="grid grid-cols-1 gap-5 pt-5">
                                    <div className="fixed inset-0 flex flex-col items-center justify-center bg-white z-50 text-center p-6">
                                        <h2 className="text-4xl font-bold text-green-600 mb-4">
                                            🎉 Your requirement is posted!
                                        </h2>
                                        <p className="text-2xl text-gray-800">
                                            Contractors will connect with you soon.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </>
                    :
                    <>
                        <div className="pt-[3%] pb-[5%]">
                            <div className="max-w-4xl mx-auto bg-white rounded-2xl shadow-lg p-8">
                                <div className="flex items-center mb-6">
                                    <h2 className="text-2xl font-semibold text-gray-800">Add Construction Requirement</h2>
                                </div>
                                <div className="grid grid-cols-1 gap-5 pt-5">
                                    <div>
                                        <label className="block mb-1 font-medium">Project Type <span className="text-red-500">*</span></label>
                                        <select
                                            className={`form-input w-full ${errors?.ProjectType ? "border-red-500" : ""}`}
                                            value={ProjectType}
                                            onChange={(e) => setProjectType(e.target.value)}
                                        >
                                            <option value="">Select Project Type</option>
                                            {AllProjectType?.map((type) => (
                                                <option key={type?._id} value={type?.Name}>
                                                    {type?.Name}
                                                </option>
                                            ))}
                                        </select>
                                        {errors?.ProjectType && <p className="text-red-500 text-sm mt-1">{errors?.ProjectType}</p>}
                                    </div>

                                    <label className="block font-medium">Size / Dimension</label>
                                    <div className="grid grid-cols-1 md:grid-cols-5 gap-4">
                                        <div>
                                            <label className="block mb-1 font-medium">Length<span className="text-red-500">*</span></label>
                                            <input
                                                type="number"
                                                placeholder="Length"
                                                className={`form-input w-full ${errors?.Length ? "border-red-500" : ""}`}
                                                value={SizeDimension.Length}
                                                onChange={(e) =>
                                                    setSizeDimension({ ...SizeDimension, Length: e.target.value })
                                                }
                                            />
                                            {errors?.Length && <p className="text-red-500 text-sm mt-1">{errors?.Length}</p>}
                                        </div>

                                        <div>
                                            <label className="block mb-1 font-medium">Breadth<span className="text-red-500">*</span></label>
                                            <input
                                                type="number"
                                                placeholder="Breadth"
                                                className={`form-input w-full ${errors?.Breadth ? "border-red-500" : ""}`}
                                                value={SizeDimension.Breadth}
                                                onChange={(e) =>
                                                    setSizeDimension({ ...SizeDimension, Breadth: e.target.value })
                                                }
                                            />
                                            {errors?.Breadth && <p className="text-red-500 text-sm mt-1">{errors?.Breadth}</p>}
                                        </div>

                                        <div>
                                            <label className="block mb-1 font-medium">Number of Floors<span className="text-red-500">*</span></label>
                                            <input
                                                type="number"
                                                placeholder="Floors"
                                                className={`form-input w-full ${errors?.NumberOfFloors ? "border-red-500" : ""}`}
                                                value={NumberOfFloors}
                                                onChange={(e) => setNumberOfFloors(e.target.value)}
                                            />
                                            {errors?.NumberOfFloors && <p className="text-red-500 text-sm mt-1">{errors?.NumberOfFloors}</p>}
                                        </div>
                                        <div>
                                            <label className="block mb-1 font-medium">Unit <span className="text-red-500">*</span></label>
                                            <select
                                                className={`form-input w-full ${errors?.Unit ? "border-red-500" : ""}`}
                                                value={SizeDimension.Unit}
                                                onChange={(e) =>
                                                    setSizeDimension({ ...SizeDimension, Unit: e.target.value })
                                                }
                                            >
                                                <option value="">Unit</option>
                                                <option value="sq. ft.">sq. ft.</option>
                                                <option value="sq. m.">sq. m.</option>
                                            </select>
                                            {errors?.Unit && <p className="text-red-500 text-sm mt-1">{errors?.Unit}</p>}
                                        </div>


                                        <div>
                                            <label className="block mb-1 font-medium">Area<span className="text-red-500">*</span></label>
                                            <input
                                                className={`form-input w-full ${errors?.Area ? "border-red-500" : ""}`}
                                                type="text"
                                                placeholder="Area"
                                                value={SizeDimension.Area}
                                                readOnly
                                            />
                                            {errors?.Area && <p className="text-red-500 text-sm mt-1">{errors?.Area}</p>}
                                        </div>
                                    </div>
                                </div>
                                <div className="grid grid-cols-1 md:grid-cols-2 gap-5 pt-5 mt-2">
                                    <div>
                                        <label className="block mb-1 font-medium">Budget</label>
                                        <select
                                            className="form-input w-full"
                                            value={Budget}
                                            onChange={(e) => setBudget(e.target.value)}
                                        >
                                            <option value="">Select Budget</option>
                                            {Array.from({ length: 20 }, (_, i) => {
                                                const start = i * 5;
                                                const end = (i + 1) * 5;
                                                return (
                                                    <option key={i} value={`${start}-${end} Lac`}>
                                                        {start} - {end} Lac
                                                    </option>
                                                );
                                            })}
                                            <option value="100+ Lac">Above 1 Crore</option>
                                        </select>
                                    </div>


                                    <div>
                                        <label className="block mb-1 font-medium">Payment Method</label>
                                        <select
                                            className="form-input w-full"
                                            value={PaymentMethod}
                                            onChange={(e) => setPaymentMethod(e.target.value)}
                                        >
                                            <option value="">Select Payment Method</option>
                                            <option value="Milestone">Milestone</option>
                                            <option value="Monthly">Monthly</option>
                                            <option value="Weekly">Weekly</option>
                                            <option value="Invoice-based Payment">Invoice-based Payment</option>
                                        </select>
                                    </div>
                                    <div className="relative group">
                                        <label className="block mb-1 font-medium flex items-center gap-2">
                                            Timeline (Months)
                                            <span className="text-gray-400 cursor-pointer">ℹ️</span>
                                        </label>
                                        <select
                                            className="form-input w-full"
                                            value={TimelineInMonths}
                                            onChange={(e) => setTimelineInMonths(e.target.value)}
                                        >
                                            <option value="">Select Timeline</option>
                                            <option value="0-2">0 - 2 Months</option>
                                            <option value="2-4">2 - 4 Months</option>
                                            <option value="4-6">4 - 6 Months</option>
                                            <option value="6-12">6 - 12 Months</option>
                                            <option value="12+">Above 12 Months</option>
                                        </select>

                                        <div className="absolute left-0 mt-1 hidden w-max max-w-xs rounded-lg bg-gray-800 px-3 py-2 text-sm text-white shadow-lg group-hover:block">
                                            Select the estimated time you expect the project to take.
                                        </div>
                                    </div>

                                    <div className="relative group">
                                        <label className="block mb-1 font-medium flex items-center gap-2">
                                            Need Local Authority Approval
                                            <span className="text-gray-400 cursor-pointer">ℹ️</span>
                                        </label>
                                        <select
                                            className="form-input w-full"
                                            value={NeedLocalAuthorityApproval}
                                            onChange={(e) => setNeedLocalAuthorityApproval(e.target.value)}
                                        >
                                            <option value="">Select</option>
                                            <option value={true}>Yes</option>
                                            <option value={false}>No</option>
                                        </select>
                                        <div className="absolute left-0 mt-1 hidden w-max max-w-xs rounded-lg bg-gray-800 px-3 py-2 text-sm text-white shadow-lg group-hover:block">
                                            Specify whether government or municipal approval is required for this project.
                                        </div>
                                    </div>

                                    <div className="md:col-span-2">
                                        <label className="block mb-2 font-medium">Select Your Location</label>
                                        <div className="w-full rounded-lg border p-3 shadow-sm">
                                            <LocationMap
                                                setLatitude={setLatitude}
                                                setLongitude={setLongitude}
                                                setLocationAddress={setLocationAddress}
                                                setCity={setCity}
                                                setState={setState}
                                                setPincode={setPincode}
                                            />
                                        </div>
                                    </div>

                                    <div>
                                        <label className="block mb-1 font-medium">State <span className="text-red-500">*</span></label>
                                        <input
                                            className={`form-input w-full ${errors?.State ? "border-red-500" : ""}`}
                                            type="text"
                                            placeholder="Enter State"
                                            value={State}
                                            onChange={(e) => setState(e.target.value)}
                                        />
                                        {errors?.State && <p className="text-red-500 text-sm mt-1">{errors?.State}</p>}
                                    </div>

                                    <div>
                                        <label className="block mb-1 font-medium">City <span className="text-red-500">*</span></label>
                                        <input
                                            className={`form-input w-full ${errors?.City ? "border-red-500" : ""}`}
                                            type="text"
                                            placeholder="Enter City"
                                            value={City}
                                            onChange={(e) => setCity(e.target.value)}
                                        />
                                        {errors?.City && <p className="text-red-500 text-sm mt-1">{errors?.City}</p>}
                                    </div>

                                    <div>
                                        <label className="block mb-1 font-medium">Pincode <span className="text-red-500">*</span></label>
                                        <input
                                            className={`form-input w-full ${errors?.Pincode ? "border-red-500" : ""}`}
                                            type="number"
                                            placeholder="Enter Pincode"
                                            value={Pincode}
                                            onChange={(e) => setPincode(e.target.value)}
                                        />
                                        {errors?.Pincode && <p className="text-red-500 text-sm mt-1">{errors?.Pincode}</p>}
                                    </div>
                                    <div>
                                        <label className="block mb-1 font-medium">Address <span className="text-red-500">*</span></label>
                                        <input
                                            className={`form-input w-full ${errors?.LocationAddress ? "border-red-500" : ""}`}
                                            type="text"
                                            placeholder="Enter Address"
                                            value={LocationAddress}
                                            onChange={(e) => setLocationAddress(e.target.value)}
                                        />
                                        {errors?.LocationAddress && <p className="text-red-500 text-sm mt-1">{errors?.LocationAddress}</p>}
                                    </div>
                                </div>


                                <div className="mt-6 pt-4">
                                    <label className="block mb-2 font-medium">Upload Project Images</label>
                                    <div className="grid grid-cols-2 md:grid-cols-3 gap-4">
                                        {Images.map((img, index) => (
                                            <div key={index} className="relative">
                                                <img
                                                    src={URL.createObjectURL(img)}
                                                    alt="Preview"
                                                    className="h-28 w-full object-cover rounded-lg border"
                                                />
                                                <button
                                                    type="button"
                                                    onClick={() => removeImage(index)}
                                                    className="absolute top-1 right-1 bg-red-500 text-white rounded-full w-6 h-6 text-xs"
                                                >
                                                    ✕
                                                </button>
                                            </div>
                                        ))}

                                        <label className="cursor-pointer">
                                            <UploadBox label="Add Image" />
                                            <input
                                                type="file"
                                                multiple
                                                accept="image/*"
                                                className="hidden"
                                                onChange={handleImageUpload}
                                            />
                                        </label>
                                    </div>
                                </div>
                                <button
                                    onClick={() => { handleUploadRequirement() }}
                                    disabled={IsLoading}
                                    className={`w-full mt-8 text-white py-3 rounded-full font-medium transition 
                    ${IsLoading ? "bg-gray-400 cursor-not-allowed" : "bg-gradient-to-r from-blue-500 to-red-500 hover:opacity-90"}`}
                                >
                                    {IsLoading ? (
                                        <div className="flex items-center justify-center">
                                            <svg
                                                className="animate-spin h-5 w-5 text-white mr-2"
                                                xmlns="http://www.w3.org/2000/svg"
                                                fill="none"
                                                viewBox="0 0 24 24"
                                            >
                                                <circle
                                                    className="opacity-25"
                                                    cx="12"
                                                    cy="12"
                                                    r="10"
                                                    stroke="currentColor"
                                                    strokeWidth="4"
                                                ></circle>
                                                <path
                                                    className="opacity-75"
                                                    fill="currentColor"
                                                    d="M4 12a8 8 0 018-8v4a4 4 0 00-4 4H4z"
                                                ></path>
                                            </svg>
                                            Loading...
                                        </div>
                                    ) : (
                                        "Submit"
                                    )}
                                </button>

                            </div>
                        </div>
                    </>
            }
        </>
    )
}

const UploadBox = ({ label }) => (
    <div className="border-dashed border-2 border-gray-300 rounded-lg h-28 flex flex-col items-center justify-center hover:border-blue-400 transition">
        <FaUpload className="text-gray-500 mb-2" />
        <span className="text-gray-700 font-medium">{label}</span>
    </div>
);

export default ConstructionRequirement